import { Link } from 'react-router-dom';
import { hotTopics, siteInfo } from '@/mocks/site';
import SectionHeading from '@/components/feature/SectionHeading';
import { articles } from '@/mocks/articles';

const tagStyle: Record<string, string> = {
  爆: 'bg-primary-500 text-background-50',
  热: 'bg-primary-100 text-primary-800',
  新: 'bg-accent-500 text-accent-950',
  议: 'bg-secondary-200 text-secondary-900',
  析: 'bg-background-200 text-foreground-700',
};

export default function HotRanking() {
  const tickerItems = [...hotTopics, ...hotTopics];
  const latestUpdates = articles.slice(0, 4);

  return (
    <section id="hot" className="w-full bg-background-100 py-12 md:py-16 scroll-mt-32">
      <div className="w-full">
        <div className="w-full border-y border-background-300 bg-background-50">
          <div className="flex items-center gap-3 py-2.5 overflow-hidden">
            <span className="shrink-0 ml-4 md:ml-8 flex items-center gap-1.5 text-xs text-primary-700">
              <i className="ri-flashlight-fill"></i>
              正在刷新
            </span>
            <div className="flex-1 overflow-hidden">
              <div className="marquee-track">
                {tickerItems.map((item, index) => (
                  <Link
                    key={`${item.slug}-${index}`}
                    to={`/article/${item.slug}`}
                    className="mx-4 text-xs text-foreground-700 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.title}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 md:px-8 pt-12 md:pt-16">
          <SectionHeading
            eyebrow="实时热榜"
            title="今日热度排行"
            description="按全网讨论量与话题增速综合排序，每十二分钟刷新一次。热度只代表讨论规模，不代表本站立场。"
            action={{ label: '查看全部事件', to: '/category/screen' }}
          />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <ol className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 divide-y divide-background-100">
              {hotTopics.map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/article/${item.slug}`}
                    className="group flex items-center gap-3 md:gap-4 px-4 md:px-5 py-3.5 hover:bg-primary-50 transition-colors cursor-pointer"
                  >
                    <span
                      className={`w-7 h-7 shrink-0 flex items-center justify-center rounded-md text-xs font-bold ${
                        item.rank <= 3
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-background-200 text-foreground-700'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="flex-1 min-w-0">
                      <span className="block text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                        {item.title}
                      </span>
                    </span>
                    <span className={`hidden sm:inline-block px-1.5 py-0.5 rounded text-[10px] shrink-0 ${tagStyle[item.tag]}`}>
                      {item.tag}
                    </span>
                    <span className="shrink-0 w-20 md:w-28">
                      <span className="block h-1.5 rounded-full bg-background-200 overflow-hidden">
                        <span
                          className="block h-full rounded-full bg-primary-400"
                          style={{ width: `${item.heat}%` }}
                        ></span>
                      </span>
                      <span className="mt-1 block text-[10px] text-foreground-500 text-right">
                        {item.heat}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>

            <aside className="rounded-lg border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h3 className="font-heading text-base font-bold text-foreground-950">
                  <i className="ri-history-line mr-1.5 text-accent-600"></i>
                  最新更新
                </h3>
                <span className="text-[10px] text-foreground-500">{siteInfo.updatedAt}</span>
              </div>
              <ul className="mt-3">
                {latestUpdates.map((item) => (
                  <li key={item.slug}>
                    <Link
                      to={`/article/${item.slug}`}
                      className="group flex gap-3 py-3 border-b border-background-100 last:border-b-0 cursor-pointer"
                    >
                      <span className="w-1.5 h-1.5 mt-2 rounded-full bg-accent-500 shrink-0"></span>
                      <span className="flex-1">
                        <span className="block text-sm text-foreground-800 group-hover:text-primary-600 transition-colors leading-snug">
                          {item.title}
                        </span>
                        <span className="mt-1 block text-xs text-foreground-500">{item.publishedAt}</span>
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
              <div className="mt-4 rounded-md bg-secondary-50 border border-secondary-200 p-3.5">
                <p className="text-xs text-secondary-900 leading-relaxed">
                  <i className="ri-information-line mr-1"></i>
                  线索投稿与勘误，请通过页面底部的订阅表单联系我们，编辑会在核实后更新。
                </p>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}